import { initializeFaro, SessionInstrumentation } from "@grafana/faro-web-sdk";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";

import { environment } from "../../../shared/src/lib/environments/environment";

export function initializeFaroRUM(): void {
  if (!environment.OTEL_ENABLED || !environment.FARO_URL) return;
  initializeFaro({
    url: environment.FARO_URL,
    app: {
      name: "admin",
      version: "1.0.0",
      environment: environment.env,
    },
    instrumentations: [
      new SessionInstrumentation(),
      new TracingInstrumentation({
        instrumentationOptions: {
          propagateTraceHeaderCorsUrls: environment.tracePropagationTargets,
        },
      }),
    ],
  });
}
